import { useState, useEffect, useRef, forwardRef } from "react";
import { useSelector, useDispatch } from "react-redux"
import { Box } from "@mui/material";
import Typography from '@mui/material/Typography';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { usePbiDeleteReportMutation } from '../features/auth/authApiSlice'
import { selectSelectedReportId, selectSelectedReportDetails, selectPBIWorkspace } from "../features/auth/authSlice"
import { selectUserData } from "../features/data/dataSlice"
import Spinner from './Spinner'
import { event } from "jquery";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
const ActionConfirm = ({ openActionConfirm, handleActionConfirmClose }) => {
  const dispatch = useDispatch()
  const [spinnerDRLoad, setSpinnerDRLoad] = useState(false)
  const [ pbiDeleteReport, { isPBIDeleteReportLoading } ] = usePbiDeleteReportMutation()

  const reportid = useSelector(selectSelectedReportId);
  const currentUserData = useSelector(selectUserData);
  const reportEmbeddObj = useSelector(selectSelectedReportDetails);
  const pbiWorkSpaceDetails = useSelector(selectPBIWorkspace);

  const reportName = reportEmbeddObj && reportEmbeddObj.name ? reportEmbeddObj.name : "";

  const buttonInput = useRef(null);

  useEffect(() => {
    if (buttonInput.current) {
      buttonInput.current.focus();
    }
  });

  const handleDeleteReport = async () => {
    setSpinnerDRLoad(true)
    const reqBody = {"reportId": reportid, "workspaceId": pbiWorkSpaceDetails}
    try {
        const responseData = await pbiDeleteReport(reqBody);
        setSpinnerDRLoad(false)
        handleActionConfirmClose()
    } catch (err) {
        console.log(err)
        setSpinnerDRLoad(false)
        handleActionConfirmClose()
    }
  }

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openActionConfirm}
        onClose={event => handleActionConfirmClose(1)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openActionConfirm}>
          <Box sx={style}>
            <Typography id="transition-modal-title" variant="h6" component="h2">
            Confirmation
            </Typography>
            <Typography id="transition-modal-description" sx={{ mt: 2 }}>
            Are you sure you want to delete the report <b>"{reportName}"</b>? The report will be PERMANENTLY deleted.
            </Typography>
            <Stack className="divlogoutbtn" direction="row" spacing={2}>
              <Button onClick={handleDeleteReport} variant="contained" color="primary" ref={buttonInput} autoFocus>Delete</Button>
              <Button variant="outlined" color="primary" onClick={event => handleActionConfirmClose(1)}>Cancel</Button>
            </Stack>
          </Box>
        </Fade>
      </Modal>
      { spinnerDRLoad && (<Spinner />) }
      </>
  );
};

export default ActionConfirm;
